import {
  accessStatusLabels,
  assignmentModeLabels,
  targetTypeLabels,
  taskStatusLabels,
  taskTypeLabels,
} from "../config";
import { isGenericHttpFailureMessage, isHttpClientError } from "../../../lib/http/errors";
import type {
  CrmCollaborationAccessStatus,
  CrmCollaborationAssignmentMode,
  CrmCollaborationTargetType,
  CrmCollaborationTaskImportResult,
  CrmCollaborationTaskStatus,
  CrmCollaborationTaskType,
} from "../types";

/** 格式化协作任务类型展示文案。 */
export function formatTaskType(value?: CrmCollaborationTaskType) {
  return value ? taskTypeLabels[value] : "-";
}

/** 格式化协作对象类型展示文案。 */
export function formatTargetType(value?: CrmCollaborationTargetType) {
  return value ? targetTypeLabels[value] : "-";
}

/** 格式化任务分配模式展示文案。 */
export function formatAssignmentMode(value?: CrmCollaborationAssignmentMode) {
  return value ? assignmentModeLabels[value] : "-";
}

/** 格式化任务批次状态展示文案。 */
export function formatTaskStatus(value?: CrmCollaborationTaskStatus) {
  return value ? taskStatusLabels[value] : "-";
}

/** 格式化任务对象权限状态展示文案。 */
export function formatAccessStatus(value?: CrmCollaborationAccessStatus) {
  return value ? accessStatusLabels[value] : "-";
}

/** 判断当前导入校验结果是否允许确认导入。 */
export function canConfirmImport(result?: CrmCollaborationTaskImportResult) {
  return Boolean(result && result.importableCount > 0);
}

/** 判断认领失败是否由任务对象状态竞争引起。 */
export function isCollaborationTaskClaimConflict(error: unknown) {
  return (
    isHttpClientError(error) &&
    error.statusCode === 409 &&
    error.code === "CRM_COLLABORATION_TASK_STATE_INVALID"
  );
}

/** 把协作任务异常转换为稳定、可理解的中文提示。 */
export function formatCollaborationTaskError(
  error: unknown,
  fallback = "协作任务操作失败，请稍后重试。",
) {
  if (isCollaborationTaskClaimConflict(error)) {
    return "该任务已被其他人认领或状态已变化，任务池已刷新，请重新选择。";
  }
  if (error instanceof Error) {
    const message = error.message.trim();
    if (message && !isGenericHttpFailureMessage(message)) {
      return message;
    }
  }
  return fallback;
}

/** 获取任务对象对应的联系人 ID。 */
export function getTargetObjectId(item: { contactId?: number }) {
  return item.contactId ?? "-";
}
